import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let navigationTimeout: NodeJS.Timeout | null = null;
let lastNavigationTime = 0;

export const useNavigationGuard = () => {
  const location = useLocation();

  useEffect(() => {
    const currentTime = Date.now();
    const timeSinceLastNav = currentTime - lastNavigationTime;
    
    // If navigating too quickly (less than 100ms), add a small delay
    if (timeSinceLastNav < 100 && navigationTimeout) {
      clearTimeout(navigationTimeout);
    }
    
    navigationTimeout = setTimeout(() => {
      lastNavigationTime = currentTime;
      
      // Clean up any extension-related DOM elements that might be orphaned
      try {
        const extensionElements = document.querySelectorAll('[data-bitwarden], [class*="autofill"], [id*="bitwarden"]');
        extensionElements.forEach(el => {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        });
      } catch (error) {
        // Silently ignore cleanup errors
      }
    }, 50);

    return () => {
      if (navigationTimeout) {
        clearTimeout(navigationTimeout);
      }
    };
  }, [location.pathname]);
};

export default useNavigationGuard;
